export default __webpack_public_path__ + "static/wechat-qrcode-f679eb491b55804ef01f390a24fa1323.jpg";